import alertService from '../AlertService';
import { needsAudio, needsWebcam } from '../HardwareRequirements';
import liveSessioner from './LiveSessioner';
import liveSessionService from './LiveSessionService';
import livestreamActions from '../../actions/LivestreamActions';
import sessionReader from '../../store/readHelpers/SessionReader';
import storeManager from '../../store/StoreManager';
import utilService from '../UtilService';
import { t } from '../i18nService';

import {
    SHOW_RECORDER_STREAMING_FAILED_MESSAGE_TIMEOUT,
    startLiveSessionError,
} from './HardwareAccessCheckConstants';

let alertTimeoutId = null;

const streamingStarterService = {
    shouldShowRecorderStreamingFailedMessage() {
        const { livestream } = storeManager.getState();
        return sessionReader.isRecordingConnectionEnforced()
            && !liveSessionService.areRequiredDevicesBeingRecorded(livestream);
    },

    shouldSkipLiveSession() {
        if (!sessionReader.isWatchAndCallEnabled()) {
            return true;
        }
        // Skip startLiveSessionStreaming for Remote Speaking.
        return sessionReader.isRemoteOralExam();
    },

    cancelRecorderAlert() {
        if (alertTimeoutId) {
            clearTimeout(alertTimeoutId);
            alertTimeoutId = null;
        }
    },

    startRecorderStreaming() {
        liveSessioner.startRecorderStreaming(needsAudio(), needsWebcam());

        if (sessionReader.isHttpRecordingEnabled()) {
            alertTimeoutId = setTimeout(() => {
                if (this.shouldShowRecorderStreamingFailedMessage()) {
                    alertService.showError(t('alert.livestream.startRecorderStreamingFailed'));
                }
            }, SHOW_RECORDER_STREAMING_FAILED_MESSAGE_TIMEOUT * 1000);
        }
    },

    abortStartStreaming(errorCode) {
        const { dispatch } = storeManager.getStore();
        const alertMessage = (errorCode === startLiveSessionError.MISSING_SESSION)
            ? t('alert.livestream.missingSessionError')
            : t('alert.livestream.startLiveSessionFailed');
        alertService.showError(alertMessage);
        dispatch(livestreamActions.abortHardwareSettings());
    },

    startStreaming(webcamDeviceId) {
        if (!utilService.isBrowserStatusOnline()) {
            this.abortStartStreaming();
            return;
        }

        const audioMaxBitrate = sessionReader.getLiveProctoringAudioBitrate();
        const videoMaxBitrate = sessionReader.getLiveProctoringVideoBitrate();

        liveSessioner.setWebCamDeviceId(webcamDeviceId);

        if (this.shouldSkipLiveSession()) {
            this.startRecorderStreaming();
            return;
        }

        liveSessioner.startLiveSessionStreaming(
            sessionReader.getAssessmentRunId(true),
            audioMaxBitrate,
            videoMaxBitrate,
            this.startRecorderStreaming.bind(this),
            this.abortStartStreaming,
        );
    },
};

export default streamingStarterService;
